export default "__VITE_ASSET__DKsEewVk__"